import { AlertOutlined, CloseOutlined } from '@ant-design/icons';
import { Empty } from 'antd';
import { useNotificationRead } from 'features/assigned-clients/use-cases/notification-read';
import { useSideBar } from 'providers/side-bar-provider';
import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { NotificationValue } from 'types/notification-dashboard';

export const NotificationDocuments = ({ notification, refetch }: any) => {
  // const [notification, SetNotification] = useState<any>(null);
  const navigate = useNavigate(); // Initialize navigation
  const { notificationCollapsed } = useSideBar();
  const { mutate } = useNotificationRead();
  // const initial = async () => {
  //   try {
  //     const apiRes = await DashBoardApiService().GetNotifications('' as any);
  //     SetNotification(apiRes);
  //   } catch (error) {
  //     console.error('Error fetchings client status graph:', error);
  //   }
  // };
  const notificationRead = (item: any) => {
    const formData = new FormData();
    formData.append('NotificationId', item?.notificationId);
    mutate(formData, {
      onSuccess: () => {
        refetch();
      },
    });
  };
  const handleCloseNotification = (item: any) => {
    notificationRead(item);
  };
  const handleNotificationClick = (item: any) => {
    if (item?.notificationTitle === NotificationValue.DocumetComment) {
      notificationRead(item);
      navigate(
        `/assign-client/${item?.companyId}/detail?clsid=${
          item?.clientId
        }&activeTab=${'4'}`,
      ); // Replace with the correct route
    } else if (
      item?.notificationTitle === NotificationValue.Adminrequesttouploaddocument
    ) {
      notificationRead(item);
      navigate(
        `/assign-client/${item?.companyId}/detail?clsid=${
          item?.clientId
        }&activeTab=${'2'}`,
      ); // Replace with the correct route
    } else if (
      item?.notificationTitle === NotificationValue.Adminuploadreportdocument
    ) {
      notificationRead(item);
      navigate(
        `/assign-client/${item?.companyId}/detail?clsid=${
          item?.clientId
        }&activeTab=${'5'}`,
      );
    } else if (
      item?.notificationTitle === NotificationValue.Clientuploaddocument
    ) {
      notificationRead(item);
      navigate(
        `/assign-client/${item?.companyId}/detail?clsid=${
          item?.clientId
        }&activeTab=${'1'}`,
      ); // Replace with the correct route
    } else if (
      item?.notificationTitle === NotificationValue.Adminrejectlegaldocument ||
      item?.notificationTitle ===
        NotificationValue.Adminapprovedlegaldocument ||
      item?.notificationTitle === NotificationValue.AdminClientUploadLegal
    ) {
      notificationRead(item);
      navigate(
        `/assign-client/${item?.companyId}/edit?temp_clie=${
          item?.clientId
        }&activeTabAssign=${'2'}`,
      );
    } else if (
      item?.notificationTitle === NotificationValue.Adminrejectdocument ||
      item?.notification == NotificationValue.Adminapproveddocument
    ) {
      notificationRead(item);
      navigate(
        `/assign-client/${item?.companyId}/detail?clsid=${
          item?.clientId
        }&activeTab=${'1'}`,
      );
    } else {
      notificationRead(item);
    }
  };
  // useEffect(() => {
  //   initial();
  // }, []);

  return (
    <Fragment>
      <div
        className={`notificationCart dscell rtbx transition-all shadow-lg rounded-lg right-0 ${
          !notificationCollapsed ? 'translate-x-full' : ''
        }`}
      >
        <div className='card '>
          <div>
            <div className='head'>
              <h3>Notifications</h3>
            </div>
            {Array.isArray(notification?.rc) && notification?.rc?.length ? (
              notification?.rc.map((item: any, index: number) => {
                return (
                  <div className='nitybx' key={index}>
                    <div className='nblst'>
                      <div className='nlicon'>
                        <AlertOutlined />
                      </div>
                      <div
                        className='nl_vlu'
                        role='button'
                        onClick={() => handleNotificationClick(item)}
                      >
                        <h3>{item?.notificationTitle}</h3>
                        <h6>{item?.notificationBody}</h6>
                        <p>{item?.notificationTime}</p>
                      </div>
                      <div
                        role='button'
                        onClick={() => handleCloseNotification(item)}
                      >
                        <CloseOutlined />
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <Empty description={'No Notification'} />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};
